module.exports = __webpack_public_path__ + "static/img/template-img4.b5b25b51.png";